<template>
	<div class="wrapper flex flex-col justify-center h-full">
		<div class="flex justify-center">
			<div class="w-10/12 sm:w-6/12 md:w-5/12 lg:w-4/12 xl:w-3/12 flex flex-col">
				<img alt="IMD-CONNECT.PRO" class="w-full p-8" src="../../assets/logo.svg" />
				<form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
					<p class="text-center mb-5 px-5">
						{{ $t('login_text') }}
					</p>

					<div class="mb-4 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="email"
							type="email"
							:placeholder="$t('e_mail')"
							v-model="email"
							ref="email"
							:required="true"
							@keyup.enter="login"
							autocomplete="username"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="envelope" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<div class="mb-6 relative">
						<input
							class="shadow appearance-none input w-full py-2 px-3 pl-12 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
							id="password"
							type="password"
							:required="true"
							:placeholder="$t('password')"
							v-model="password"
							@keyup.enter="login"
							autocomplete="current-password"
							ref="password"
						/>
						<div class="absolute flex border border-transparent left-0 top-0 h-full w-10">
							<div class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full">
								<font-awesome-icon icon="key" class="h-5 w-5"></font-awesome-icon>
							</div>
						</div>
					</div>

					<div class="flex flex-col md:flex-row items-center justify-between" v-if="showCheckboxSavePassword">
						<BaseCheckbox :filter-only="true" label="Passwort speichern?" v-model="savePassword" />
					</div>

					<div class="flex flex-col md:flex-row items-center justify-between">
						<a
							class="inline-block align-baseline font-bold text-sm text-blue-sp hover:text-blue-800 mb-5 md:mb-0 cursor-pointer"
							@click="goToResetPassword"
						>
							{{ $t('forgot_password') }}
						</a>
						<BaseButton @click.prevent="login" class="btn-blue">{{ $t('log_in') }}</BaseButton>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import Authentication from '@/mixins/Authentication';

function init(event) {
	if (window.appcontainer.component) {
		window.appcontainer.isiOSEmployeeApp = event?.detail?.isEmployeeApp;
		window.appcontainer.component.showCheckboxSavePassword = true;
		window.removeEventListener('init_appcontainer', init);
		window.appcontainer
			.getLoginCredentials()
			.then(credentials => {
				window.appcontainer.isiOSAppcontainer = true;
				if (credentials && credentials.email && credentials.password) {
					window.appcontainer.component.$refs.email.value = credentials.email;
					window.appcontainer.component.$refs.password.value = credentials.password;
				}

				window.appcontainer.component = null;
			})
			.catch(error => {
				//console.error(error)
			});
	}
}
window.addEventListener('init_appcontainer', init);

import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import BaseButton from '@/components/forms/buttons/BaseButton';
export default {
	name: 'Login',
	components: { BaseButton, BaseCheckbox },
	mixins: [Authentication],
	data() {
		return {
			email: '',
			password: '',
			savePassword: true,
			showCheckboxSavePassword: false,
		};
	},
	mounted() {
		const input = this.$refs.email;
		input.focus();
		window.appcontainer.component = this;
		if (window.appcontainer.isiOSAppcontainer) {
			init();
		}
	},
	methods: {
		goToResetPassword() {
			this.$router.push({ name: 'resetpassword' });
		},
		login() {
			/**
			 * Chrome/Safari bug
			 * https://github.com/vuejs/vue/issues/7058
			 * No input event on autofill
			 */
			this.password = this.$refs.password.value;
			this.email = this.$refs.email.value;

			if (this.email && this.password) {
				this.$store
					.dispatch({ type: 'login', email: this.email, password: this.password })
					.then(() => {
						if (this.savePassword && window.appcontainer.isiOSAppcontainer) {
							window.appcontainer.saveLoginCredentials(this.email, this.password);
						} else {
							window.appcontainer.saveLoginCredentials(null, null);
						}

						setTimeout(() => {
							if (this.isUserAllowedInLevel5or6 && !this.$store.getters.getUser.stripePaymentStored) {
								this.$router.push({ name: 'ManagePayment' });
							} else if (this.isUserAllowedInLevel5or6) {
								this.$router.push({ name: 'management' });
							} else if (this.isUserAllowedInLevel2 || this.isUserAllowedInLevel3) {
								this.$router.push({ name: 'damagecases' });
							} else {
								this.$router.push({ name: 'Dashboard' });
							}
						}, 500);
					})
					.catch(error => {
						const response = error.response;
						if (response && response.status === 429) {
							this.$swal(this.$t('general.error').toString(), this.$t('too_many_requests').toString(), 'error');
						} else if (response && response.status === 401) {
							this.$swal(this.$t('general.error').toString(), this.$t('incorrect_credentials').toString(), 'error');
						} else if (response && response.status === 405) {
							this.$swal(this.$t('general.error').toString(), this.$t('company_account_locked').toString(), 'error');
						} else if (response && response.status === 455) {
							this.$swal(this.$t('general.error').toString(), this.$t('error_contact_customer_consultant').toString(), 'error');
						} else {
							this.$swal(this.$t('general.error').toString(), this.$t('error_occurred').toString(), 'error');
						}
					});
			} else {
				this.$swal(this.$t('general.error').toString(), this.$t('please_check_input').toString(), 'error');
			}
		},
	},
};
</script>

<style lang="sass" scoped>
.wrapper
	background-color: #e9ecef

.text-blue-sp
  color: #0068B4

input[type="password"]
	font-family: -apple-system, BlinkMacSystemFont, sans-serif
	-webkit-appearance: none
	appearance: none
	-webkit-text-security: disc

input[type="password"]::placeholder
	font-family: "Source Sans Pro", -apple-system, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"
	font-size: inherit
</style>
